import React, { useEffect, useState } from 'react'
import './Weather.css'
import cloud from './cloudy.png'
import sun from './sun.png'
import rainfall from './rainy-day.png'
import mist from './mist.png'
import search from './search.png'
import humidity from './humidity.png'
import storm from './storm.png'
import axios from 'axios'
function Weather() 
{
  const [name, setname] = useState("london");
  const [url, seturl] = useState();
  const [imgurl, setimgurl] = useState(sun);
  const [Data, setData] = useState({
    name:"londan",
    Celcius:"",
    speed:"",
    humidity:""
  });

  function SubmitEvent()
  {
    if(name !="")
    {
      const url =`https://api.openweathermap.org/data/2.5/weather?q=${name}&appid=aba47323cd8cabb3b58b394fe8e3de1e&units=metric`;
      seturl(url);
      axios.get(url).then((res)=>{
        if(res.data.weather[0].main =='clear')
        {
          setimgurl(sun);
        }   
        else if(res.data.weather[0].main =='Rain')
        {
          setimgurl(rainfall);
        }        
        else if(res.data.weather[0].main =='Mist')
        {
          setimgurl(mist);
        }
        else if(res.data.weather[0].main =='Clouds')
        {
          setimgurl(cloud);
        }
          console.log(res);
        setData({...Data, name: res.data.main.name , Celcius: res.data.main.temp, humidity:res.data.main.humidity , speed:res.data.wind.speed})}).catch((err)=> console.log(err));
    }
  }
  useEffect(() => {
    const url = "https://api.openweathermap.org/data/2.5/weather?q=aba47323cd8cabb3b58b394fe8e3de1e&units=metric";

  }, [])  
  


  return (
    <div className='weather-container'>
      <h1>Weather App</h1>
        <div className="inner-container">
          <div className="search">
            <input type='text' placeholder='search city' value={name} onChange={(e)=>{setname(e.target.value)}}></input>
            <img src={search} style={{height:"25px",width:"25px"}} onClick={SubmitEvent}></img>
          </div>
          <div className="weather-info">
          <h1>{name}</h1>
            <div className="logo">
              <img src={imgurl} style={{height:"100px",width:"100px"}}></img>
              <h3>{Data.Celcius}°C</h3>
            </div>
            <div className="details-container">
            <div className="col">
              <img src={storm} ></img>
              <h1>{Data.speed}</h1>
            </div>
            <div className="col">
            <img src={humidity}></img>
              <h1>{Data.humidity}</h1>
            </div>
            </div>
          </div>
        </div>
        
        
    </div>
  )
}

export default Weather